import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
    { label: "Services", href: "#services" },
    { label: "Work", href: "#portfolio" },
    { label: "About", href: "#about" },
    { label: "Pricing", to: "/services/web-development" },
    { label: "Booking", href: "#booking" },
    { label: "Contact", href: "#contact" },
];

export const scrollTo = (href) => (e) => {
    if (e) e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export const bookService = (serviceId) => (e) => {
    if (e) e.preventDefault();
    window.dispatchEvent(new CustomEvent("cw:book-service", { detail: serviceId }));
    document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
    const [open, setOpen] = useState(false);
    const go = (href) => (e) => {
        setOpen(false);
        scrollTo(href)(e);
    };
    const bookDev = (e) => {
        setOpen(false);
        bookService("web-dev")(e);
    };
    return (
        <header data-testid="site-nav" className="fixed top-0 inset-x-0 z-50 border-b border-ink/10 bg-paper/85 backdrop-blur-md">
            <div className="mx-auto max-w-7xl px-5 md:px-10 h-16 flex items-center justify-between">
                <a href="#top" onClick={go("#top")} data-testid="nav-logo" className="flex items-center gap-3">
                    <img src="/assets/icon-512.png" alt="Consulting WorX logo" className="h-9 w-9" />
                    <span className="font-display font-semibold tracking-tight text-lg">Consulting WorX</span>
                </a>
                <nav className="hidden md:flex items-center gap-8 text-sm">
                    {LINKS.map((l) =>
                        l.to ? (
                            <Link
                                key={l.label}
                                to={l.to}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="text-ink/70 hover:text-worx transition-colors duration-200"
                            >
                                {l.label}
                            </Link>
                        ) : (
                            <a
                                key={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                href={l.href}
                                onClick={go(l.href)}
                                className="text-ink/70 hover:text-worx transition-colors duration-200"
                            >
                                {l.label}
                            </a>
                        )
                    )}
                </nav>
                <div className="flex items-center gap-3">
                    <a
                        href="#booking"
                        onClick={bookDev}
                        data-testid="nav-book-cta"
                        className="hidden sm:inline-flex items-center gap-1.5 bg-ink text-paper px-4 py-2 text-sm hover:bg-worx transition-colors duration-200"
                    >
                        Book a free consult <ArrowUpRight size={14} />
                    </a>
                    <button
                        data-testid="nav-menu-toggle"
                        aria-label="Toggle menu"
                        className="md:hidden p-2"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>
            </div>
            {open && (
                <div data-testid="nav-mobile-menu" className="md:hidden border-t border-ink/10 bg-paper px-5 py-4 flex flex-col gap-4">
                    {LINKS.map((l) =>
                        l.to ? (
                            <Link
                                key={l.label}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                className="text-base"
                            >
                                {l.label}
                            </Link>
                        ) : (
                            <a key={l.href} data-testid={`nav-mobile-link-${l.label.toLowerCase()}`} href={l.href} onClick={go(l.href)} className="text-base">
                                {l.label}
                            </a>
                        )
                    )}
                    <a href="#booking" onClick={bookDev} data-testid="nav-mobile-book-cta" className="inline-flex items-center gap-1.5 bg-ink text-paper px-4 py-2.5 text-sm w-max">
                        Book a free consult <ArrowUpRight size={14} />
                    </a>
                </div>
            )}
        </header>
    );
};
